/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MediaCategoriesResponse } from '../../models/media-categories-response';

export interface GetMediaBlogPostsCategories$Params {
}

export function getMediaBlogPostsCategories(http: HttpClient, rootUrl: string, params?: GetMediaBlogPostsCategories$Params, context?: HttpContext): Observable<StrictHttpResponse<MediaCategoriesResponse>> {
  const rb = new RequestBuilder(rootUrl, getMediaBlogPostsCategories.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MediaCategoriesResponse>;
    })
  );
}

getMediaBlogPostsCategories.PATH = '/rest/media/blog-category';
